import { createFileRoute, notFound } from '@tanstack/react-router';

import { UnsubscribeRoute } from '@mint-emails/recommendation/routes';
import { z } from 'zod';

export const Route = createFileRoute('/recommendation/unsubscribe')({
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw notFound();
    }
  },
  component: RouteComponent,
  validateSearch: z.object({
    token: z.string(),
  }),
});

function RouteComponent() {
  return <UnsubscribeRoute />;
}
